var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 46,
    viewBox: "0 0 69 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6579,
    cy: 40.2839,
    r: 5.06416,
    fill: "#242A30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.25 10.0625C15.5276 10.0625 10.0625 15.5244 10.0625 22.2813C10.0625 27.9803 13.9566 32.7715 19.2181 34.1202C21.9097 34.8102 23.5324 37.5515 22.8424 40.2432C22.1525 42.9348 19.4111 44.5575 16.7195 43.8675C7.10403 41.4028 0 32.6748 0 22.2813C0 9.98427 9.95308 0 22.25 0C24.8628 0 27.3808 0.453114 29.7229 1.28928C32.3398 2.22355 33.7039 5.10234 32.7696 7.71926C31.8354 10.3362 28.9566 11.7002 26.3396 10.766C25.0678 10.3119 23.6934 10.0625 22.25 10.0625Z",
    fill: "url(#paint0_linear_950_962)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1598 1.4375C49.0842 1.4375 50.84 2.53521 51.6828 4.26522L68.4905 38.7653C69.7075 41.2633 68.669 44.2749 66.171 45.4918C63.673 46.7088 60.6614 45.6703 59.4444 43.1723L47.1598 17.9564L41.178 30.2348C39.961 32.7328 36.9494 33.7713 34.4514 32.5543C31.9534 31.3373 30.9149 28.3258 32.1319 25.8277L42.6367 4.26522C43.4796 2.53521 45.2354 1.4375 47.1598 1.4375Z",
    fill: "url(#paint1_linear_950_962)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4307 1.90193C51.9287 3.11891 52.9672 6.1305 51.7502 8.62851L41.2454 30.191C40.0284 32.689 37.0168 33.7275 34.5188 32.5105C32.0208 31.2936 30.9823 28.282 32.1993 25.784L42.7041 4.22144C43.9211 1.72343 46.9327 0.684948 49.4307 1.90193Z",
    fill: "url(#paint2_linear_950_962)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_950_962",
    x1: 23.9289,
    y1: 22.6694,
    x2: -0.00861165,
    y2: 3.77131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_950_962",
    x1: 46.6057,
    y1: 11.3304,
    x2: 64.2438,
    y2: 45.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_950_962",
    x1: 34.0082,
    y1: 31.4873,
    x2: 47.8668,
    y2: 5.03007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185ADB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon-login.ab3db2918b25cc1c1b557c6bb9aaca89.svg";
export { ForwardRef as ReactComponent };